/* stylelint-disable block-no-empty */
import type { SerializedStyles } from "@emotion/react";
import { css } from "@emotion/react";
import { theme } from "@product/scmp-sdk";

export type Breakpoint = (typeof theme.breakpoints.keys)[number];
type BreakpointUpKey = `${Breakpoint}Up`;
export type RequiredBreakpointKey = Extract<BreakpointUpKey, "mobileUp" | "tabletUp" | "desktopUp">;
export type OptionalBreakpointKey = Exclude<BreakpointUpKey, RequiredBreakpointKey>;
export type ResponsiveVariants<T> = Record<RequiredBreakpointKey, T> &
  Partial<Record<OptionalBreakpointKey, T>>;
type VariantStyleFunction<T> = (variant: T) => SerializedStyles | null;

export function setResponsiveVariantStyles<T>(
  responsiveVariants: ResponsiveVariants<T>,
  computeStylesFromVariant: VariantStyleFunction<T>,
) {
  return css`
    ${theme.breakpoints.up("mobile")} {
      ${computeStylesFromVariant(responsiveVariants.mobileUp)}
    }
    ${theme.breakpoints.up("tablet")} {
      ${computeStylesFromVariant(responsiveVariants.tabletUp)}
    }
    ${theme.breakpoints.up("desktop")} {
      ${responsiveVariants.desktopUp && computeStylesFromVariant(responsiveVariants.desktopUp)}
    }
    ${theme.breakpoints.up("homeDesktop")} {
      ${responsiveVariants.homeDesktopUp &&
      computeStylesFromVariant(responsiveVariants.homeDesktopUp)}
    }
    ${theme.breakpoints.up("mediumDesktop")} {
      ${responsiveVariants.mediumDesktopUp &&
      computeStylesFromVariant(responsiveVariants.mediumDesktopUp)}
    }
    ${theme.breakpoints.up("largeDesktop")} {
      ${responsiveVariants.largeDesktopUp &&
      computeStylesFromVariant(responsiveVariants.largeDesktopUp)}
    }
    ${theme.breakpoints.up("xLargeDesktop")} {
      ${responsiveVariants.xLargeDesktopUp &&
      computeStylesFromVariant(responsiveVariants.xLargeDesktopUp)}
    }
  `;
}
